import {InfoOutlined} from '@mui/icons-material'
import {Tooltip, Typography} from '@mui/material'

import {KpiScore} from '../kpiScore'

import {SummaryScoreProps} from './types'

export const SummaryScore = ({
  label,
  value,
  subscriptValue,
  valueVariant,
  showTooltip = false,
  tooltip,
  dataTestId
}: SummaryScoreProps) => {
  const content = (
    <KpiScore
      label={label}
      labelIcon={showTooltip ? <InfoOutlined /> : undefined}
      value={value}
      unit={subscriptValue}
      variant={valueVariant}
      data-test-id={dataTestId}
      valueSxProp={{whiteSpace: 'nowrap'}}
    />
  )

  return showTooltip ? (
    <Tooltip
      arrow
      placement="right"
      title={
        tooltip && typeof tooltip === 'string' ? (
          <Typography fontWeight="medium">{tooltip}</Typography>
        ) : (
          tooltip
        )
      }
    >
      <span>{content}</span>
    </Tooltip>
  ) : (
    content
  )
}
